module.exports = __webpack_public_path__ + "static/media/GroupeDeMasque.13f3b7b6.svg";